<!--通用弹窗-->
<template>
    <ModalTemplate :visible="store.state.isShowAlert" @handleCloseOver="handleCloseOver">
        <div class="tip-content" :class="currentChannel.channel">
            <!-- v-if="isShowHeader" -->
            <div class="title display-y-center display-x-center">
                {{ t(alertData.title ? alertData.title : 'common.1') }}
            </div>
            <div class="content">
                <div class="msg" v-html="alertData.msg" />
            </div>
            <div class="btn-content">
                <div class="btn-cancel" v-if="alertData.btnType == 1" @click="onClickCancel" v-html="alertData.cancelText ? alertData.cancelText : t('common.6')">
                </div>
                <div class="btn-confirm" @click="onClickConfirm" v-html="alertData.confirmText ? alertData.confirmText : t('common.2')">
                </div>
            </div>
            <img v-if="alertData.isShowClose" class="btn-close" src="@/assets/images/common/btn_close.png" @click="onClickClose" />
        </div>
    </ModalTemplate>
</template>

<script lang="ts" setup>
import { currentChannel } from '@/config/config';
import { AlertData } from '@/utils/Define';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import ModalTemplate from '../common/ModalTemplate.vue';
import { showAlert } from '@/utils/function';


    const { t } = useI18n();
    const store = useStore();
    const alertData = computed(() => {
        return store.state.alertData as AlertData;
    });
    const closeType = ref(0);

defineProps({
    // title: {
    //     type: String,
    //     default: "xxxx",
    // },
    // isShowClose: {
    //     type: Boolean,
    //     default: true
    // },
    // isShowHeader: {
    //     type: Boolean,
    //     default: true,
    // },
});

const emits = defineEmits(["onClose"]);

function onClickCancel() {
    closeType.value = 1;
    store.state.isShowAlert = false;
    // if (alertData.value.cancelCall) {
    //     alertData.value.cancelCall();
    // }
    // hideAlert();
}

function onClickConfirm() {
    closeType.value = 2;
    store.state.isShowAlert = false;
    // if (alertData.value.confirmCall) {
    //     alertData.value.confirmCall();
    // }
    // hideAlert();
}

function onClickClose() {
    closeType.value = 3;
    store.state.isShowAlert = false;
    // if (alertData.value.closeCall) {
    //     alertData.value.closeCall();
    // }
    // hideAlert();
}

function hideAlert() {
    showAlert(false, <AlertData>{});
}

function handleCloseOver() {
    switch(closeType.value) {
        case 1:
            alertData.value.cancelCall && alertData.value.cancelCall();
            break;
        case 2:
            alertData.value.confirmCall && alertData.value.confirmCall();
            break;
        case 3:
            alertData.value.closeCall && alertData.value.closeCall();
            break;
    }
    hideAlert();
}
</script>

<style lang="less" scoped>
.tip-content {
    width: 345rem;
    height: auto;
    background-color: #0B151E;
    border-radius: 5rem;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 10rem;
    .title {
        width: 100%;
        height: 50rem;
        font-size: 20rem;
        font-weight: bold;
        color: #FFF;
        border-radius: 10rem 10rem 0 0;
        padding: 0 10rem;
        box-sizing: border-box;
    }
    .content {
        position: relative;
        background: #0F1D29;
        // min-height: 148rem;
        padding: 10rem;
        white-space: pre-wrap;
        .msg{
            font-family: Roboto;
            font-weight: 400;
            font-size: 16rem;
            color: #FFFFFF;
            white-space: pre-wrap;
        }

    }

    .btn-content{
        padding: 0 10rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 44rem;
        margin-top: 10rem;

        font-family: Roboto;
        font-weight: 700;
        font-size: 14rem;
        text-align: center;
        gap: 10rem;

        .btn-cancel{
            width: 155rem;
            height: 100%;
            background: #162A3B;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFFFFF;
            border-radius: 5rem;
        }
        
        .btn-confirm{
            border-radius: 5rem;
            flex: 1;
            height: 100%;
            background: #FFD645;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000000;
        }
    }
    &.EG {
        .title {
            >img {
                right: auto;
                left: 0;
            }
        }
    }
}
.btn-close {
    width: 30rem;
    height: 30rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 104%;
}
</style>